import { render, staticRenderFns } from "./AssignedTeamsList.vue?vue&type=template&id=0b2ade7d&scoped=true"
import script from "./AssignedTeamsList.vue?vue&type=script&lang=js"
export * from "./AssignedTeamsList.vue?vue&type=script&lang=js"
import style0 from "./AssignedTeamsList.vue?vue&type=style&index=0&id=0b2ade7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2ade7d",
  null
  
)

export default component.exports